import { v4, validate } from 'uuid';

export const createGuid = () => v4();

export const validateGuid = (guid) => validate(guid);
